import _ from "@/boot/lodash";
import type { ICurrency } from "@upmind-automation/types";

export default {
  computed: {
    currencies(): ICurrency[] {
      return this.$store.state.constants.currencies;
    }
  },
  data: () => ({
    currenciesLoaded: false,
    isLoggedOut: false
  }),
  async created() {
    await this.getCurrencies();
    this.currenciesLoaded = true;
  },
  methods: {
    getCurrencies() {
      return this.$store.dispatch("constants/getCurrencies", {
        isLoggedOut: this.isLoggedOut
      });
    },
    getCurrencyCode(currencyId) {
      return _.get(_.find(this.currencies, ["id", currencyId]), "code", "");
    }
  }
};
